// Importation des images
import don41rmic from '../assets/actualitesdumusee/don41rmic.jpg';
import latransformation from '../assets/actualitesdumusee/latransformation.jpg';
import nouvelleexpo from '../assets/actualitesdumusee/nouvelleexpo.jpg';
import coloneldetrentinian from '../assets/actualitesdumusee/coloneldetrentinian.jpg';
import dienbienphuenvitrine from '../assets/actualitesdumusee/dienbienphuenvitrine.jpg';
import lastatuedegallieni from '../assets/actualitesdumusee/lastatuedegallieni.jpg';
import lebaroudeur from '../assets/actualitesdumusee/lebaroudeur.jpg';
import ouverturedumusee from '../assets/actualitesdumusee/ouverturedumusee.jpg';
import conference20250213 from '../assets/actualitedelaamtdm/conference20250213.jpg';
import ag2025 from '../assets/actualitedelaamtdm/ag2025.jpg';
import conference20241212histoiremilitaireatraversleschants from '../assets/actualitedelaamtdm/conference20241212histoiremilitaireatraversleschants.jpg';
import conference20241114laliberationdelacorse from '../assets/actualitedelaamtdm/conference20241114laliberationdelacorse.jpg';
import conference20241010laffaireclaustre from '../assets/actualitedelaamtdm/conference 20241010 laffaireclaustre.jpg';
import conference20240208citadellesstdomingue from '../assets/actualitedelaamtdm/conference20240208citadellesstdomingue.jpg';
import conference20240411lestirailleurssenegalais from '../assets/actualitedelaamtdm/conference20240411lestirailleurssenegalais.jpg';
import conference20240614lacommemorationdebazeilles from '../assets/actualitedelaamtdm/conference20240614lacommemorationdebazeilles.jpg';
import conference20240314sas from '../assets/actualitedelaamtdm/conference20240314sas.jpg';
import conference20240516peintureetpropagandenapoleonienne from '../assets/actualitedelaamtdm/conference20240516peintureetpropagandenapoleonienne.jpg';
import conference20231116museecolo from '../assets/actualitedelaamtdm/conference20231116museecolo.jpg';
import conference20231221attentatdrakkar from '../assets/actualitedelaamtdm/conference20231221attentatdrakkar.png';
import conference20240125leondebeylie from '../assets/actualitedelaamtdm/conference20240125leondebeylie.jpg';
import conference20231005tule from '../assets/actualitedelaamtdm/conference20231005tule.jpg';
import conference20250612leszouaves from '../assets/actualitedelaamtdm/conference20250612leszouaves.jpg';
import conference20250515guerredurif from '../assets/actualitedelaamtdm/conference20250515guerredurif.jpg';
import conference20250410leonlafrance from '../assets/actualitedelaamtdm/conference20250410leonlafrance.jpg';
import conference20250402canada from '../assets/actualitedelaamtdm/conference20250402canada.jpg';
import conference20250313planeursliberation from '../assets/actualitedelaamtdm/conference20250313planeursliberation.jpg';
import expowaterloo1 from '../assets/actualitesdumusee/expowaterloo1.jpg';
import nuitDesMusees20250517 from '../assets/actualitesdumusee/20250517nuitdesmusees.png';
import societesMilitairesPrivees from '../assets/actualitedelaamtdm/conference20251016essocietesmilitairesprivees.jpg';
import parachutagesAtterissagesEnProvence from '../assets/actualitedelaamtdm/conference20251113parachutagesatterrissagesenprovence.jpg';
import lesChantsMilitaires from '../assets/actualitedelaamtdm/conference20251211leschantsmilitaires.jpg';
import RATDMAffiche from '../assets/actualitedelaamtdm/20250831ratdmaffiche.jpg';
import NapoleonFrejus from '../assets/actualitesdumusee/20250916napoleonfrejus.jpg';
import HistoireTDM from '../assets/actualitedelaamtdm/conference20251016histoiredestdm.jpg';
import LouMisteriou from '../assets/actualitesdumusee/LouMisteriou.jpg';
import AG2026 from '../assets/actualitedelaamtdm/20260131ag.png';
import PeintresArmee from '../assets/actualitesdumusee/peintresarmee.jpg';
import conference20260212Authion from '../assets/actualitedelaamtdm/conference20260212authion.jpg';
import conference20260409MaquisVallier from '../assets/actualitedelaamtdm/conference20260409MaquisVallier.jpg';
import lhistoiresaffiche from '../assets/actualitesdumusee/lhistoiresaffiche.jpg';
import conference20260507madagascar1895 from '../assets/actualitedelaamtdm/conference20260507madagascar1895.jpg';
import conference20260611Veracruz1838 from '../assets/actualitedelaamtdm/conference20260611veracruz1838.jpg';
import conference20261008medecindebrousse from '../assets/actualitedelaamtdm/conference20261008medecindebrousse.jpg';
import conference20261112chantpatriotique from '../assets/actualitedelaamtdm/conference20261112chantpatriotique.jpg';
import conference20261210coree from '../assets/actualitedelaamtdm/conference20261210coree.jpg';
import ag2027 from '../assets/actualitedelaamtdm/ag2027.jpg';
import jep2026 from '../assets/actualitesdumusee/jep2026.jpg';
import nuitdesmusees2026 from '../assets/actualitesdumusee/nuitdesmusees2026.jpg';
import bazeilles2026 from '../assets/actualitedelaamtdm/bazeilles2026.png';
import bulleMemoire2026 from '../assets/actualitesdumusee/bullememoire2026.jpg';     
import bazeilles2026Inscriptions from '../assets/actualitedelaamtdm/bazeilles2026inscriptions.png';   
import forumAssoFrejus2026 from '../assets/actualitedelaamtdm/forumassofrejus2026.jpg';
import forumAssoStRaph2026 from '../assets/actualitedelaamtdm/forumassostraph2026.jpg';
import uttdm2026 from '../assets/actualitesdumusee/uttdm2026.jpg';
import conference20261008labatailleddessollies from '../assets/actualitedelaamtdm/conference20261008labatailledessollies.jpg';
import flamencoMusee from '../assets/actualitesdumusee/flamencomusee.jpg';


// Importation des PDFs
import don41rmicPdf from '../assets/actualitesdumusee/don41rmic.pdf';
import latransformationPdf from '../assets/actualitesdumusee/latransformation.pdf';
import nouvelleexpoPdf from '../assets/actualitesdumusee/nouvelleexpo.pdf';
import coloneldetrentinianPdf from '../assets/actualitesdumusee/coloneldetrentinian.pdf';
import dienbienphuenvitrinePdf from '../assets/actualitesdumusee/dienbienphuenvitrine.pdf';
import lastatuedegallieniPdf from '../assets/actualitesdumusee/lastatuedegallieni.pdf';
import lebaroudeurPdf from '../assets/actualitesdumusee/lebaroudeur.pdf';
import ouverturedumuseePdf from '../assets/actualitesdumusee/ouverturedumusee.pdf';
import conference20250213Pdf from '../assets/actualitedelaamtdm/conference20250213.pdf';
import ag2025Pdf from '../assets/actualitedelaamtdm/ag2025.pdf';
import conference20241212histoiremilitaireatraversleschantsPdf from '../assets/actualitedelaamtdm/conference20241212histoiremilitaireatraversleschants.pdf';
import conference20241114laliberationdelacorsePdf from '../assets/actualitedelaamtdm/conference20241114laliberationdelacorse.pdf';
import conference20241010laffaireclaustrePdf from '../assets/actualitedelaamtdm/conference 20241010 laffaireclaustre.pdf';
import conference20240208citadellesstdominguePdf from '../assets/actualitedelaamtdm/conference20240208citadellesstdomingue.pdf';
import conference20240411lestirailleurssenegalaisPdf from '../assets/actualitedelaamtdm/conference20240411lestirailleurssenegalais.pdf';
import conference20240614lacommemorationdebazeillesPdf from '../assets/actualitedelaamtdm/conference20240614lacommemorationdebazeilles.pdf';
import conference20240314sasPdf from '../assets/actualitedelaamtdm/conference20240314sas.pdf';
import conference20240516peintureetpropagandenapoleoniennePdf from '../assets/actualitedelaamtdm/conference20240516peintureetpropagandenapoleonienne.pdf';
import conference20231116museecoloPdf from '../assets/actualitedelaamtdm/conference20231116museecolo.pdf';
import conference20231221attentatdrakkarPdf from '../assets/actualitedelaamtdm/conference20231221attentatdrakkar.pdf';
import conference20240125leondebeyliePdf from '../assets/actualitedelaamtdm/conference20240125leondebeylie.pdf';
import conference20231005tulePdf from '../assets/actualitedelaamtdm/conference20231005tule.pdf';
import conference20250612leszouavesPdf from '../assets/actualitedelaamtdm/conference20250612leszouaves.pdf';
import conference20250515guerredurifPdf from '../assets/actualitedelaamtdm/conference20250515guerredurif.pdf';
import conference20250410leonlafrancePdf from '../assets/actualitedelaamtdm/conference20250410leonlafrance.pdf';
import conference20250402canadaPdf from '../assets/actualitedelaamtdm/conference20250402canada.pdf';
import conference20250313planeursliberationPdf from '../assets/actualitedelaamtdm/conference20250313planeursliberation.pdf';
import expowaterloo1Pdf from '../assets/actualitesdumusee/expowaterloo1.pdf';
import nuitDesMuseesPdf20250517Pdf from '../assets/actualitesdumusee/20250517nuitdesmusees.pdf';
import societesMilitairesPriveesPdf from '../assets/actualitedelaamtdm/conference20251016essocietesmilitairesprivees.pdf';
import parachutagesAtterissagesEnProvencePdf from '../assets/actualitedelaamtdm/conference20251113parachutagesatterrissagesenprovence.pdf';
import lesChantsMilitairesPdf from '../assets/actualitedelaamtdm/conference20251211leschantsmilitaires.pdf';
import RATDMProgrammePdf from '../assets/actualitedelaamtdm/20250831ratdmprogramme.pdf';
import NapoleonFrejusPdf from '../assets/actualitesdumusee/20250916napoleonfrejus.pdf';
import HistoireTDMPdf from '../assets/actualitedelaamtdm/conference20251016histoiredestdm.pdf';
import LouMisteriouPdf from '../assets/actualitesdumusee/LouMisteriou.pdf';
import AG2026PDF from '../assets/actualitedelaamtdm/20260131ag.pdf';
import PeintresArmeePdf from '../assets/actualitesdumusee/peintresarmee.pdf';
import conference20260212AuthionPdf from '../assets/actualitedelaamtdm/conference20260212authion.pdf';
import conference20260409MaquisVallierPdf from '../assets/actualitedelaamtdm/conference20260409MaquisVallier.pdf';
import lhistoiresaffichePdf from '../assets/actualitesdumusee/lhistoiresaffiche.pdf';
import conference20260507madagascar1895Pdf from '../assets/actualitedelaamtdm/conference20260507madagascar1895.pdf';
import conference20260611Veracruz1838Pdf from '../assets/actualitedelaamtdm/conference20260611veracruz1838.pdf';
import conference20261008medecindebroussePdf from '../assets/actualitedelaamtdm/conference20261008medecindebrousse.pdf';
import conference20261112chantpatriotiquePdf from '../assets/actualitedelaamtdm/conference20261112chantpatriotique.pdf';
import conference20261210coreePdf from '../assets/actualitedelaamtdm/conference20261210coree.pdf';
import ag2027Pdf from '../assets/actualitedelaamtdm/ag2027.pdf';
import jep2026Pdf from '../assets/actualitesdumusee/jep2026.pdf';
import nuitdesmusees2026Pdf from '../assets/actualitesdumusee/nuitdesmusees2026.pdf';
import bazeilles2026Pdf from '../assets/actualitedelaamtdm/bazeilles2026.pdf';
import bulleMemoire2026Pdf from '../assets/actualitesdumusee/bullememoire2026.pdf';
import bazeilles2026InscriptionsPdf from '../assets/actualitedelaamtdm/bazeilles2026inscriptions.pdf';
import forumAssoFrejus2026Pdf from '../assets/actualitedelaamtdm/forumassofrejus2026.pdf';
import forumAssoStRaph2026Pdf from '../assets/actualitedelaamtdm/forumassostraph2026.pdf';
import uttdm2026Pdf from '../assets/actualitesdumusee/uttdm2026.pdf';
import conference20261008labatailleddessolliesPdf from '../assets/actualitedelaamtdm/conference20261008labatailledessollies.pdf';
import flamencoMuseePdf from '../assets/actualitesdumusee/flamencomusee.pdf';

// Tableau des articles
const articles = [
    {
        id: 1,
        title: "Le fragment retrouvé du drapeau du 41e RMIC",
        date: "21 janvier 2025",
        description: "L'incroyable histoire du Colonel (H) Tristani et de ses officiers.",
        image: don41rmic,
        pdfPath: don41rmicPdf,
        link: "/article4",
        category: "musee",
        conference: false,
    },
    {
        id: 2,
        title: "Le Musée des TDM a achevé sa transformation",
        date: "25 novembre 2024",
        description: "Le musée dévoîle au public l'ultime partie de son parcours de visite.",
        image: latransformation,
        pdfPath: latransformationPdf,
        link: "/article4",
        category: "musee",
        conference: false,
    },
    {
        id: 3,
        title: "Nouvelle expo au musée",
        date: "25 Octobre 2024",
        description: "Le Musée des Troupes de Marine rend hommage aux libérateurs de la Provence, puis de la France.",
        image: nouvelleexpo,
        pdfPath: nouvelleexpoPdf,
        link: "/article4",
        category: "musee",
        conference: false,
    },
    {
        id: 4,
        title: "Un portrait aussi beau qu'énigmatique",
        date: "25 mai 2024",
        description: "L'association des amis du musée des Troupes de Marine font l'acquisition d'une pièce d'exception.",
        image: coloneldetrentinian,
        pdfPath: coloneldetrentinianPdf,
        link: "/article4",
        category: "musee",
        conference: false,
    },
    {
        id: 5,
        title: "Diên Biên Phu en vitrine",
        date: "20 mai 2024",
        description: "Diên Biên Phu tient une place toute particulière dans l'histoire des Troupes de Marine.",
        image: dienbienphuenvitrine,
        pdfPath: dienbienphuenvitrinePdf,
        link: "/article3",
        category: "musee",
        conference: false,
    },
    {
        id: 6,
        title: "La statue équestre du Général Gallieni",
        date: "15 mars 2024",
        description: "Elle est aujourd'hui l'élément central de la place d'armes du 21ème RIMA.",
        image: lastatuedegallieni,
        pdfPath: lastatuedegallieniPdf,
        link: "/article2",
        category: "musee",
        conference: false,
    },
    {
        id: 7,
        title: "Le baroudeur au musée",
        date: "10 janvier 2024",
        description: "Jean Louis Delayen, surnommé aussi le baroudeur, a combattu dans pas moins de quatre guerres.",
        image: lebaroudeur,
        pdfPath: lebaroudeurPdf,
        link: "/article1",
        category: "musee",
        conference: false,
    },
    {
        id: 8,
        title: "Le musée des Troupes de Marine est ouvert!",
        date: "25 Octobre 2022",
        description: "Après plus de deux ans de travaux, le musée des Troupes de Marine rouvre plus beau que jamais !",
        image: ouverturedumusee,
        pdfPath: ouverturedumuseePdf,
        link: "/article4",
        category: "musee",
        conference: false,
    },
    {
        id: 9,
        title: "Comprendre la bataille de Waterloo",
        date: "13 février 2025",
        description: "Une conférence de Marc Morillon, ancien Directeur de l'Institut de médecine tropicale au service de santé des armées",
        image: conference20250213,
        pdfPath: conference20250213Pdf,
        link: "/article1",
        category: "association",
        conference: true,
    },
    {
        id: 10,
        title: "Assemblée Générale 2025",
        date: "15 janvier 2025",
        description: "L'Assemblée Générale de l'AAMTDM aura lieu le 25/01/2025.",
        image: ag2025,
        pdfPath: ag2025Pdf,
        link: "/article1",
        category: "association",
        conference: false,
    },
    {
        id: 11,
        title: "L'histoire militaire à travers les chants",
        date: "12 décembre 2024",
        description: "Une conférence de Michel Sancho, membre de l'International Military Music Society",
        image: conference20241212histoiremilitaireatraversleschants,
        pdfPath: conference20241212histoiremilitaireatraversleschantsPdf,
        link: "/article4",
        category: "association",
        conference: true,
    },
    {
        id: 12,
        title: "La libération de la Corse",
        date: "14 novembre 2024",
        description: "Une Conférence de Vincent Giraudier, responsable du département de l'Historial Charles de Gaulle au musée de l'Armée",
        image: conference20241114laliberationdelacorse,
        pdfPath: conference20241114laliberationdelacorsePdf,
        link: "/article3",
        category: "association",
        conference: true,
    },
    {
        id: 13,
        title: "L'affaire Claustre",
        date: "10 octobre 2024",
        description: "Une conférence de Francis Simonis, professeur de l'université d'Aix-Marseille",
        image: conference20241010laffaireclaustre,
        pdfPath: conference20241010laffaireclaustrePdf,
        link: "/article2",
        category: "association",
        conference: true,
    },
    {
        id: 14,
        title: "Les citadelles de Saint-Domingue",
        date: "08 février 2024",
        description: "Une conférence de Nicolas Faucherre (Université Aix-Marseille) et de Laurent Pavlidis (Conservateur du musée de la Citadelle de Saint-Tropez)",
        image: conference20240208citadellesstdomingue,
        pdfPath: conference20240208citadellesstdominguePdf,
        link: "/article4",
        category: "association",
        conference: true,
    },
    {
        id: 15,
        title: "Les tirailleurs sénégalais dans le sud-est de la France",
        date: "11 Avril 2024",
        description: "Une conférence d'Anthony Guyon, docteur en histoire militaire, Sciences Po Paris",
        image: conference20240411lestirailleurssenegalais,
        pdfPath: conference20240411lestirailleurssenegalaisPdf,
        link: "/article4",
        category: "association",
        conference: true,
    },
    {
        id: 16,
        title: "La commémoration de Bazeilles",
        date: "14 Juin 2024",
        description: "Une conférence du lieutenant Marteau, enseignant-chercheur à l'Académie militaire de St Cyr-Coëtquidan",
        image: conference20240614lacommemorationdebazeilles,
        pdfPath: conference20240614lacommemorationdebazeillesPdf,
        link: "/article4",
        category: "association",
        conference: true,
    },
    {
        id: 17,
        title: "Août 1944, les SAS français du Limousin au Jura",
        date: "14 Mars 2024",
        description: "Une conférence de David Portier, petit-fils de résistant",
        image: conference20240314sas,
        pdfPath: conference20240314sasPdf,
        link: "/article4",
        category: "association",
        conference: true,
    },
    {
        id: 18,
        title: "Peinture et propagande napoléonienne",
        date: "16 Mai 2024",
        description: "Une conférence de Marc Morillon, ancien Directeur de l'Institut de médecine tropicale au service de santé des armées",
        image: conference20240516peintureetpropagandenapoleonienne,
        pdfPath: conference20240516peintureetpropagandenapoleoniennePdf,
        link: "/article4",
        category: "association",
        conference: true,
    },
    {
        id: 19,
        title: "Des officiers des troupes de marine parmi les donateurs du musée colonial de Marseille : un simple fruit du hasard ?",
        date: "16 Novembre 2023",
        description: "Une conférence de Brigitte Sabattini, Maître de conférences à l'université d'Aix-Marseilles",
        image: conference20231116museecolo,
        pdfPath: conference20231116museecoloPdf,
        link: "/article4",
        category: "association",
        conference: true,
    },
    {
        id: 20,
        title: "L'attentat contre le poste DRAKKAR, à Beyrouth, le 23 octobre 1983",
        date: "25 Décembre 2023",
        description: "Une conférence du général Bernard Serpol.",
        image: conference20231221attentatdrakkar,
        pdfPath: conference20231221attentatdrakkarPdf,
        link: "/article4",
        category: "association",
        conference: true,
    },
    {
        id: 21,
        title: "Le général Léon de Beylié et a mise en patrimoine d'Angkor.",
        date: "25 janvier 2024",
        description: "Une conférence de Jean-François Klein, professeur à l'Académie de Saint-Cyr Coëtquidan",
        image: conference20240125leondebeylie,
        pdfPath: conference20240125leondebeyliePdf,
        link: "/article4",
        category: "association",
        conference: true,
    },
    {
        id: 22,
        title: "Le 6ème Bataillon de parachutistes coloniaux à Tu Lê (Tonkin)",
        date: "5 Octobre 2023",
        description: "Une conférence du colonel Jean Luc Martin",
        image: conference20231005tule,
        pdfPath: conference20231005tulePdf,
        link: "/article4",
        category: "association",
        conference: true,
    },
    {
        id: 23,
        title: "Les Zouaves",
        date: "12 Juin 2025",
        description: "Une conférence du colonel Jean-Louis Lemmet",
        image: conference20250612leszouaves,
        pdfPath: conference20250612leszouavesPdf,
        link: "/article4",
        category: "association",
        conference: true,
    },
    {
        id: 24,
        title: "La Guerre du RIF 1925",
        date: "15 Mai 2025",
        description: "Une conférence d'Aurélia Dusserre, de l'université Aix-Marseille",
        image: conference20250515guerredurif,
        pdfPath: conference20250515guerredurifPdf,
        link: "/article4",
        category: "association",
        conference: true,
    },
    {
        id: 25,
        title: "Léon La France 1900",
        date: "10 Avril 2025",
        description: "Une conférence de Jean-Charles Clanet",
        image: conference20250410leonlafrance,
        pdfPath: conference20250410leonlafrancePdf,
        link: "/article4",
        category: "association",
        conference: true,
    },
    {
        id: 26,
        title: "Les officiers des troupes de la Marine au Canada 1683-1760",
        date: "2 Avril 2025",
        description: "Une conférence de Marcel Fournier, historien canadien",
        image: conference20250402canada,
        pdfPath: conference20250402canadaPdf,
        link: "/article4",
        category: "association",
        conference: true,
    },
    {
        id: 27,
        title: "Les planeurs de la Libération 1944",
        date: "13 Mars 2025",
        description: "Une conférence de Philippe Esvelin",
        image: conference20250313planeursliberation,
        pdfPath: conference20250313planeursliberationPdf,
        link: "/article4",
        category: "association",
        conference: true,
    },
    {
        id: 28,
        title: "Une bataille Napoléonienne... comme si vous y étiez",
        date: "2 Avril 2025",
        description: "Une maquette de 100 m² avec pas moins de 22 000 figurines !",
        image: expowaterloo1,
        pdfPath: expowaterloo1Pdf,
        link: "/article4",
        category: "musee",
        conference: null,
    },
    {
        id: 29,
        title: "La nuit des Musées au Musée des Troupes de Marine",
        date: "17 Mai 2025",
        description: "Le musée des Troupes de Marine vous ouvre ses portes",
        image: nuitDesMusees20250517,
        pdfPath: nuitDesMuseesPdf20250517Pdf,
        link: "/article4",
        category: "musee",
        conference: false,
    },

    {
        id: 31,
        title: "Parachutages et atterrissages en Provence",
        date: "13 Novembre 2025",
        description: "Une conférence de Laurent Gensonnet, professeur d'histoire au lycée Saint-Louis, à Orange",
        image: parachutagesAtterissagesEnProvence,
        pdfPath: parachutagesAtterissagesEnProvencePdf,
        link: "/article4",
        category: "association",
        conference: true,
    },

    {
        id: 32,
        title: "Les chants militaires",
        date: "11 Décembre 2025",
        description: "Une conférence de Michel Sancho, ingénieur de l'armement.",
        image: lesChantsMilitaires,
        pdfPath: lesChantsMilitairesPdf,
        link: "/article4",
        category: "association",
        conference: true,
    },

    {
        id: 33,
        title: "Rassemblement annuel des Troupes de marine à Fréjus",
        date: "31 Août 2025",
        description: "Du 31 Août au 1er Septembre, l’anniversaire des combats de Bazeilles rassemblera à Fréjus jeunes et anciens desTroupes de marine ainsi que leurs sympathisants sous le thème « Agir au loin »",
        image: RATDMAffiche,
        pdfPath: RATDMProgrammePdf,
        link: "/article4",
        category: "association",
        conference: false,
    },
    {
        id: 34,
        title: "Fréjus l'impériale",
        date: "16 Septembre 2025",
        description: "Repérez vos sites napoléoniens pour une balade dans l'Histoire au coeur de Fréjus",
        image: NapoleonFrejus,
        pdfPath: NapoleonFrejusPdf,
        link: "/article4",
        category: "musee",
        conference: false,
    },
    {
        id: 35,
        title: "L'Histoire des Troupes de Marine",
        date: "16 Octobre 2025",
        description: "Une conférence de Marc Morillon, ancien Directeur de l'Institut de médecine tropicale au service de santé des armées",
        image: HistoireTDM,
        pdfPath: HistoireTDMPdf,
        link: "/article4",
        category: "association",
        conference: true
    },

    {
        id: 36,
        title: "Napoléon - Coeur et Sang : un spectacle historique",
        date: "5 Octobre 2025",
        description: "Entrée gratuite sur réservation à l'Office de Tourisme de Fréjus",
        image: LouMisteriou,
        pdfPath: LouMisteriouPdf,
        link: "/article4",
        category: "musee",
        conference: false
    },

    {
        id: 36,
        title: "Les Sociétés Militaires Privées",
        date: "12 mars 2026",
        description: "Une conférence du Colonel (er) PEER DE JONG, co-fondateur et vice-président de THEMIIS",
        image: societesMilitairesPrivees,
        pdfPath: societesMilitairesPriveesPdf,
        link: "/article4",
        category: "association",
        conference: true
    }  ,
    
    {
        id: 37,
        title: "Assemblée Générale 2026",
        date: "31 Janvier 2026",
        description: "L'Assemblée Générale de l'AAMTDM aura lieu le 31/01/2026. Participez-y.",
        image: AG2026,
        pdfPath: AG2026PDF,
        link: "/article1",
        category: "association",
        conference: false,
    },
    {
      id: 38,
      title: "Les peintres de l'armée exposent",
      date: "03 février 2026 au 29 mars 2026",
      description: "Les peintres de l'armée exposent du 3 février au 29 mars 2026 au musée des Troupes de Marine.",
      image: PeintresArmee,
      pdfPath: PeintresArmeePdf,
      link: "/article4",
      category: "musee",
      conference: false
    },

    {
        id: 39,
        title: "La bataille d'Authion - 1945",
        date: "12 février 2026",
        description: "Une conférence du lieutenant-colonel Philippe Guyot, historien et conservateur au musée de l'Armée",
        image: conference20260212Authion,
        pdfPath: conference20260212AuthionPdf,
        link: "/article4",
        category: "association",
        conference: true
    },

    {
        id: 40,
        title: "Maquis Vallier et maquis du Var : 1943 - 1944",
        date: "09 Avril 2026",
        description: "Une conférence de Jean-Marc Guillot, professeur honoraire de l'unviversité d'Aix-Marseille en histoire contemporaine.",
        image: conference20260409MaquisVallier,
        pdfPath: conference20260409MaquisVallierPdf,
        link: "/article4",
        category: "association",
        conference: true
    },

   {
        id: 41,
        title: "L'histoire s'affiche",
        date: "28 avril 2026 au 13 décembre 2026",
        description: "Le musée des Troupes de marine vous propose un voyage singulier dans l’histoire contemporaine de la France et de ses ex-colonies",
        image: lhistoiresaffiche,
        pdfPath: lhistoiresaffichePdf,
        link: "/article4",
        category: "musee",
        conference: false
    },

   {
        id: 42,
        title: "L'expédition de Madagascar de 1894 - 1895",
        date: "07 mai 2026 ",
        description: "Une conférence de Gaël Bay, expert des conflits armés.",
        image: conference20260507madagascar1895,
        pdfPath: conference20260507madagascar1895Pdf,
        link: "/article4",
        category: "association",
        conference: true
    },

    {
        id: 43,
        title: "La guerre des pâtisseries, 1838",
        date: "18 juin 2026 ",
        description: "Une conférence de Marc Morillon, médecin militaire et professeur agrégé du Val de Grâce.",
        image: conference20260611Veracruz1838,
        pdfPath: conference20260611Veracruz1838Pdf,
        link: "/article4",
        category: "association",
        conference: true
    },


    {
        id: 44,
        title: "La vie quotidienne d'un médecin de brousse en Afrique dans les années 70",
        date: "10 décembre 2026",
        description: "Une conférence de Marcel Merlin",
        image: conference20261008medecindebrousse,
        pdfPath: conference20261008medecindebroussePdf,
        link: "/article4",
        category: "association",
        conference: true
    },


    {
        id: 45,
        title: "Les chants de la Grande Guerre, patriotiques et même revenchards, côtoient des chants plus nostalgiques voire de révolte",
        date: "12 novembre 2026 ",
        description: "Une conférence de Michel Sancho",
        image: conference20261112chantpatriotique,
        pdfPath: conference20261112chantpatriotiquePdf,
        link: "/article4",
        category: "association",
        conference: true
    },

    {
        id: 47,
        title: "Assemblée Générale",
        date: "30 janvier 2027",
        description: "L'Assemblée Générale de l'AAMTDM aura lieu le 30 janvier 2027",
        image: ag2027,
        pdfPath: ag2027Pdf,
        link: "/article4",
        category: "association",
        conference: true
    },

    {
        id: 48,
        title: "Journées Européennes du patrimoine",
        date: "19 septembre 2026 au 20 septembre 2026",
        description: "Les Journées Européennes du patrimoine auront lieu les 19 et 20 septembre 2026",
        image: jep2026,
        pdfPath: jep2026Pdf,
        link: "/article4",
        category: "musee",
        conference: false
    },

    {
        id: 49,
        title: "Nuit du musée",
        date: "23 mai 2026",
        description: "Le musée des Troupes de Marine participe à la Nuit du musée le 23 mai 2026",
        image: nuitdesmusees2026,
        pdfPath: nuitdesmusees2026Pdf,
        link: "/article4",
        category: "musee",
        conference: false
    },

    {
        id: 50,
        title: "Bazeilles",
        date: "31 août 2026 au 1 septembre 2026",
        description: "Le musée des Troupes de Marine se joint aux commémorations de Bazeilles",
        image: bazeilles2026,
        pdfPath: bazeilles2026Pdf,
        link: "/article4",
        category: "aamtdm",
        conference: false,
    },

    {
        id: 51,
        title: "Bulle Mémoire 2026",
        date: "3 juin 2026",
        description: "Remise de prix du concours BD",
        image: bulleMemoire2026,
        pdfPath: bulleMemoire2026,
        link: "/article4",
        category: "musee",
        conference: false,
    },

    {
        id:52,
        title: "Les inscriptions pour Bazeilles 2026 sont ouvertes",
        date: "31 août 2026",
        description: "Réservez votre place avant le 15 août 2026",
        image: bazeilles2026Inscriptions,
        pdfPath: bazeilles2026InscriptionsPdf,
        link: "/article4",
        category: "aamtdm",
        conference: false,
    },

        {
        id:54,
        title: "Forum des associations de Saint-Raphaël",
        date: "5 septembre 2026",
        description: "L'AAMTDM sera présente au forum des associations de Saint-Raphaël le 5 septembre 2026",
        image: forumAssoStRaph2026,
        pdfPath: forumAssoStRaph2026Pdf,
        link: "/article4",
        category: "aamtdm",
        conference: false,
    },

    {
        id:53,
        title: "Forum des associations de Fréjus",
        date: "6 septembre 2026",
        description: "L'AAMTDM sera présente au forum des associations de Fréjus le 6 septembre 2026",
        image: forumAssoFrejus2026,
        pdfPath: forumAssoFrejus2026Pdf,
        link: "/article4",
        category: "aamtdm",
        conference: false,
    },

    {
        id:55,
        title: "UTTDM 2026",
        date: "21 novembre 2026 au 22 novembre 2026",
        description: "Le musée des Troupes de marine accueillera l'UTTDM 2026 les 21 et 22 novembre",
        image: uttdm2026,
        pdfPath: uttdm2026Pdf,
        link: "/article4",
        category: "musee",
        conference: false,
    },
    {
        id:56,
        title: "La bataille du Verrou des Solliès",
        date: "8 octobre 2026",
        description: "Une conférence du Général René Grisolle",
        image: conference20261008labatailleddessollies,
        pdfPath: conference20261008labatailleddessolliesPdf,
        link: "/article4",
        category: "association",
        conference: true,
    },

    {
        id:57,
        title: "Le Flamenco s'invite au musée des Troupes de Marine", 
        date: "19 septembre 2026 au 20 septembre 2026",
        description: "A l'occasion des journées européennes du patrimoine, venez assister à une représentation de flamenco au musée des Troupes de Marine",
        image: flamencoMusee,
        pdfPath: flamencoMuseePdf,
        link: "/article4",
        category: "musee",
        conference: false,}
    
     
];

export default articles;
